import type { StatusGroupRes } from 'api/swagger';

export const isFullyLoaded = (statuses: StatusGroupRes[]) => {
  const result = statuses.find(
    (status) => status.type === 'waiting' || (status.type === 'planned' && !status.fromWarehouseId),
  );

  return !result;
};

export const isFullyCompleted = (statuses: StatusGroupRes[]) => {
  if (statuses.length > 1) return false;

  return statuses[0].type === 'delivered';
};
